if (!customElements.get('included-slider')) {
  class IncludedSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.flickity = new Flickity(this, {
        accessibility: false,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        cellAlign: 'left'
      });
    }
  }

  customElements.define('included-slider', IncludedSlider);
}
